import Button from '@components/actions/button';
import React from 'react';
import styled from 'styled-components';
import { Translate } from 'react-localize-redux';

type Props = { goToMerch: () => void };

export const CreateMerchProduct = ({ goToMerch }: Props) => {
  return (
    <StyledMerchProduct>
      <StyledImageNLabelContainer>
        <StyledProductImage />
        <StyledLabel>
          <Translate id="ARTIST_SITE.MERCH.CREATE_PRODUCT.LABEL" />
        </StyledLabel>
      </StyledImageNLabelContainer>

      <StyledButton buttonType="primary" onClick={goToMerch}>
        <Translate id="ARTIST_SITE.MERCH.CREATE_PRODUCT.BUTTON_LABEL" />
      </StyledButton>
    </StyledMerchProduct>
  );
};

const StyledMerchProduct = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px;
  border: 1px dashed #8b8b8b4d;
  margin-bottom: 10px;
  border-radius: 4px;
`;

const StyledButton = styled(Button)`
  ${({ theme }) => `@media screen and ${theme.device.tablet}`} {
    max-width: 146px;
  }
`;

const StyledLabel = styled.label`
  font-size: 18px;
  line-height: 22px;
  color: ${({ theme }) => theme.colors.primary};
`;

const StyledImageNLabelContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StyledProductImage = styled.div`
  border-radius: 50%;
  width: 32px;
  height: 32px;
  background: #e2e3e8;
  margin-right: 10px;
`;
